import { useForm } from "@mantine/form";
import { useAuth } from "../context/AuthContext";
import { PasswordInput, TextInput, Button } from "@mantine/core";
import PageHeader from "../components/common/PageHeader";
import { createAdminUser } from "../api/adminUserApi";
import { creationNotification } from "../utils/useNotification";
import styled from "styled-components";
import Container from "../components/common/Container";
import { ActionIcon } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router";

import {
  combineValidators,
  validateMaxLength,
  validateMinLength,
  validateNoSpaces,
  validatePhoneNumberIsNumeric,
  validatePhoneNumberStartsWithZero,
  validateRequired,
} from "../utils/validations";

const NewAdminUser = () => {
  const { adminUser } = useAuth();
  const navigate = useNavigate();


  const form = useForm({
    initialValues: {
      username: "",
      name: "",
      phone: "",
      password: "",
    },
    validate: {
      name: validateRequired,
      phone: combineValidators(
        validateRequired,
        validatePhoneNumberStartsWithZero,
        validatePhoneNumberIsNumeric,
        validateNoSpaces,
        validateMinLength(11)
      ),
      password: combineValidators(
        validateRequired,
        validateMaxLength(16),
        validateMinLength(4)
      ),
    },
  });

  const handleSubmit = async (values: object) => {
    if (adminUser) {
      try {
        const { data }: any = await createAdminUser({
          ...values,
        });
        creationNotification("Admin Kullanıcısı", data?.success);
        form.reset();
        navigate("/admin-users");
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <Container>
      <ActionIcon 
        variant="subtle" 
        color="#5c26ff" 
        size={44}
        onClick={() => navigate("/admin-users")} 
      >
        <IconArrowLeft size={28} />
      </ActionIcon>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "40px",
          alignItems: "center",  
          justifyContent: "center", 
          minHeight: "70vh", 
          width: "100%", 
        }}
      >
        <PageTitle>
          <Title>Yeni Admin Kullanıcısı Kaydı</Title>
        </PageTitle>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
            width: "min(468px, 100%)",
          }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <TextInput
            label="Kullanıcı Adı"
            placeholder="Kullanıcı Adı Giriniz."
            radius={10}
            size="md"
            {...form.getInputProps("username")}
            maxLength={40}
          />
          <TextInput
            label="Ad Soyad"
            placeholder="Ad Soyad Giriniz."
            radius={10}
            size="md"
            {...form.getInputProps("name")}
            maxLength={40}
          />

          <TextInput
            label="Telefon"
            placeholder="Telefon Giriniz."
            radius={10}
            size="md"
            maxLength={11}
            {...form.getInputProps("phone")}
          />
          <PasswordInput
            label="Şifre"
            placeholder="Şifre Giriniz."
            radius={10}
            size="md"
            maxLength={16}
            {...form.getInputProps("password")}
          />

          <Button color="#5C26FF" radius={10} type="submit">
            Oluştur
          </Button>
        </form>
      </div>
    </Container>
  );
};

export default NewAdminUser;

const PageTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 12px;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  color: black;
`;
